export const SITE_URL = 'https://vkfestpay.juice.vk-apps.com';
export const APP_ID = 7026764;



// WEBPACK FOOTER //
// ./src/js/services/_globals.js